import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { CreditDataResultModel } from "@tSurya/Services/CustomCreateAccountService";
import { DisplayFormOrderParameter, displayorder } from "@tSurya/Services/DisplayForm/DisplayFormService";

type HandlerType = ApiHandler<
DisplayFormOrderParameter & HasOnSuccess<any>,
any
>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await displayorder(props.apiParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.(props.apiResult);
};


export const chain = [PopulateApiParameter, RequestDataFromApi, ExecuteOnSuccessCallback];

const displayOrderForm = createHandlerChainRunner(chain, "displayOrderForm");
export default displayOrderForm;
